import { CellPropsBase, CellTitle, CellValueArea, FormCell } from '.'
import { SelectOption } from '../../../../model/selectOption'
import { MultiSelect } from '../../../../components/inputs/MultiSelect'
import { useMemo } from 'react'
import { renderOption } from '../../../../components/select/variations'

type MultiSelectCellProps = {
  value: string[] | undefined
  onChange?: (v: string[] | undefined) => void
  options: SelectOption[]
  displayIcon?: boolean
} & CellPropsBase

export const MultiSelectCell = ({
  label,
  help,
  options,
  value: _value,
  editable,
  onChange,
  cellWidth,
  required,
  displayIcon = false,
  edited,
  validationErrors,
}: MultiSelectCellProps) => {
  const value = useMemo(() => _value || [], [_value])
  return (
    <FormCell cellWidth={cellWidth}>
      <CellTitle title={label} required={required} help={help} />
      <CellValueArea edited={edited} validationErros={validationErrors}>
        <MultiSelect
          value={value}
          onChange={onChange}
          options={options}
          clearable={editable}
          disabled={!editable}
          renderOption={renderOption}
        />
      </CellValueArea>
    </FormCell>
  )
}
